import type { JSX, ReactNode } from 'react';

export interface ITooltip {
	children?: ReactNode;
	tipElement?: JSX.Element;
	// Render the tip in a body portal with a fixed strategy so an overflow ancestor can't clip it.
	unclipped?: boolean;
}

export const normalizePlacement = (placement?: string) => {
	if (!placement) return '';
	if (placement.startsWith('top')) return ' top';
	if (placement.startsWith('bottom')) return ' bottom';
	if (placement.startsWith('left')) return ' left';
	if (placement.startsWith('right')) return ' right';
	return '';
};

export interface ITooltipContent {
	content: string;
	linkTitle?: string;
	linkUrl?: string;
	onLinkClick?: () => void;
	loading?: boolean;
}
